import { is } from 'bpmn-js/lib/util/ModelUtil';

// --- Helper function (module scope) ---

function formatTimestamp(seconds) {
  const s = Number.parseFloat(seconds);
  if (Number.isNaN(s)) return seconds;
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
}

/**
 * Adds a ⏱ badge overlay on Task elements that have a custom:videoTimestamp set.
 * Clicking the badge fires a custom event so the VideoPlayer can seek to that time.
 */
export default function VideoTimestampOverlayProvider(eventBus, overlays, elementRegistry) {
  const overlayMap = {};

  function createBadgeHtml(timestamp) {
    const badge = document.createElement('div');
    badge.className = 'video-timestamp-badge';
    badge.title = 'Video: ' + formatTimestamp(timestamp) + ' – Klicken zum Abspielen';
    badge.textContent = '🎬';
    badge.addEventListener('click', function (e) {
      e.stopPropagation();
      eventBus.fire('videoPlayer.seekTo', { timestamp: Number.parseFloat(timestamp) });
    });
    return badge;
  }

  function updateOverlay(element) {
    if (!element?.businessObject || !is(element, 'bpmn:Task')) return;

    const elementId = element.id;

    // Remove existing
    if (overlayMap[elementId]) {
      try { overlays.remove(overlayMap[elementId]); } catch { /* already removed */ }
      delete overlayMap[elementId];
    }

    const timestamp = element.businessObject.get('custom:videoTimestamp');
    if (timestamp) {
      try {
        overlayMap[elementId] = overlays.add(element, 'video-timestamp', {
          position: {
            bottom: 4,
            right: 30
          },
          html: createBadgeHtml(timestamp),
          show: { minZoom: 0.3 },
          scale: { min: 1, max: 1 }
        });
      } catch (error_) {
        console.warn('Could not add video timestamp overlay:', error_);
      }
    }
  }

  function updateAll() {
    elementRegistry.forEach(function (element) {
      updateOverlay(element);
    });
  }

  eventBus.on('element.changed', function (event) {
    updateOverlay(event.element);
  });

  eventBus.on('import.done', function () {
    updateAll();
  });

  eventBus.on('commandStack.changed', function () {
    updateAll();
  });
}

VideoTimestampOverlayProvider.$inject = ['eventBus', 'overlays', 'elementRegistry'];
